export default {
    getFormatted(date, options, sep){
        function format(m) {
            let f = new Intl.DateTimeFormat('en', m);
            return f.format(date);
        }
        return options.map(format).join(sep);
    },

    getYearsArray: function(minYear){
        let min = Number(minYear)
        let max = (new Date()).getFullYear()
        let arr = []
        for(let i = min; i <= max; i++){
            arr.push(i)
        }

        return arr;
    },

    toISO(date){
        let tzo = -date.getTimezoneOffset(),
            dif = tzo >= 0 ? '+' : '-',
            pad = function(num) {
                return (num < 10 ? '0' : '') + num;
            };

        return date.getFullYear() +
            '-' + pad(date.getMonth() + 1) +
            '-' + pad(date.getDate()) +
            'T' + pad(date.getHours()) +
            ':' + pad(date.getMinutes()) +
            ':' + pad(date.getSeconds()) +
            dif + pad(Math.floor(Math.abs(tzo) / 60)) +
            ':' + pad(Math.abs(tzo) % 60);
    },

    /**
     * Normalize a date value for date-only form controls without converting an
     * existing YYYY-MM-DD value through UTC. Date of birth values represent a
     * calendar day, not an instant in time, so timezone conversion must not be
     * allowed to move them to the previous or next day.
     */
    toDateOnly(value){
        if(value == null || value === '')
            return ''

        if(typeof value === 'string'){
            const dateOnly = value.match(/^\d{4}-\d{2}-\d{2}/)
            if(dateOnly)
                return dateOnly[0]
        }

        const date = value instanceof Date ? value : new Date(value)
        if(Number.isNaN(date.getTime()))
            return ''

        const pad = number => String(number).padStart(2, '0')
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
    },

    toDate(year, month, day){
        let d = new Date();
        d.setFullYear(year, month + 1, day)
        return d;
    },

    dateArray(arr){
        let d = new Date();
        d.setFullYear(arr[0], arr[1], arr[1])
        return d;
    },
    fromJavaInstant(instant){
        return (new Date(instant * 1000))
    }
}
